import { LoginPage, LoginTypeEnum } from "@crispico/foundation-react/pages/loginPage/LoginPage";
import { Form, Label, Button, Message, Icon, SemanticShorthandItem, TabPaneProps, Grid } from "semantic-ui-react";
import React from "react";
import { humanResourceEntityDescriptor } from "AppEntityDescriptors";
import { AuthenticationStatus } from "@crispico/foundation-react/apollo-gen-foundation/globalTypes";
import { Utils } from "@crispico/foundation-react/utils/Utils";
import { XOPS_MOBILE_SETTINGS_PATH, XopsMobileWrapper } from "./XopsMobile/XopsMobileWrapper";
import { NavLink } from "react-router-dom";
import { LoginParamsInput } from "apollo-gen/globalTypes";
import { mobileDeviceEntityDescriptor } from "./MobileDevice/mobileDeviceEntityDescriptor";
import { AppContainerContext } from "@crispico/foundation-react/AppContainerContext";
import { XopsAppContainerContextValue } from "XopsAppContainerContext";

// extend from LoginTypeEnum
// tip found here: https://devimalplanet.com/typescript-how-to-extend-one-enum-from-another
export const XopsLoginTypeEnum = { ...LoginTypeEnum, HRLOGIN: 'HRLOGIN', ALVESTLOGIN: "ALVESTLOGIN" } as const;
type XopsLoginTypeEnum = typeof XopsLoginTypeEnum[keyof typeof XopsLoginTypeEnum];
export class XopsLoginPage extends LoginPage {
    static contextType = AppContainerContext;
    context!: XopsAppContainerContextValue;

    protected backgroundImageURL() {
        if (XopsMobileWrapper.isDeviceMobileApp() || XopsMobileWrapper.isDeviceWindowsApp()) {
            return undefined;
        }
        return super.backgroundImageURL();
    }

    componentDidMount(): void {
        // TODO CC: temporary code until we decide where to keep the config for OMS mobile
        // now the sessionStorage is removed at logout, so we lose the flag!
        // we need to keep putting it in local state & sessionStorage
        if (XopsMobileWrapper.isDeviceMobileApp() || XopsMobileWrapper.isDeviceWindowsApp()) {
            if (Utils.isNullOrEmpty(window.sessionStorage.getItem("login.type"))) {
                window.sessionStorage.setItem("login.type", XopsLoginTypeEnum.HRLOGIN);
                this.setState({ loginType: XopsLoginTypeEnum.HRLOGIN });
            }
        }
        super.componentDidMount?.();
    }
    
    protected verifyCredentials(username: string, password: string, otpToken: string) {
        if (this.state.loginType === XopsLoginTypeEnum.HRLOGIN) {
            if (Utils.isNullOrEmpty(password)) {
                this.loginCallback(AuthenticationStatus.FAILURE, _msg("XopsLoginPage.pdaIdentifier.notNull", _msg("HumanResource.pdaIdentifier.label")));
                return false;
            }
            return true;
        }
        return super.verifyCredentials(username, password, otpToken);
    }

    protected getPanes(): {
        pane?: SemanticShorthandItem<TabPaneProps>
        menuItem?: any
        render?: () => React.ReactNode
    }[] {
        const panes = [...super.getPanes(),
        {
            pane: { loginType: XopsLoginTypeEnum.HRLOGIN as string },
            menuItem: { key: XopsLoginTypeEnum.HRLOGIN as string, icon: humanResourceEntityDescriptor.getIcon(), content: _msg("XopsLoginPage.label") },
            render: () => this.renderHRLoginTab()
        }];
        if (this.context.initializationsForClient.alvestAuthenticationEnabled) {
            panes.push({
                pane: { loginType: XopsLoginTypeEnum.ALVESTLOGIN as string },
                menuItem: { key: XopsLoginTypeEnum.ALVESTLOGIN as string, icon: <Icon name="external" />, content: _msg("AlvestLoginPage.label") },
                render: () => this.renderAlvestLoginTab()
            });
        }
        return panes;
    }

    protected renderHRLoginTab() {
        return this.renderLoginForm(this.renderPasswordInput(_msg("XopsLoginPage.humanResource.placeholder"), true));
    }

    protected renderAlvestLoginTab() {
        return this.renderLoginForm([this.renderUsernameInput(_msg("User.email.label"), true), this.renderPasswordInput(_msg("login.password"))]);
    }

    protected renderLoginForm(formFields: JSX.Element | JSX.Element[]) {
        return <Form error onSubmit={this.onSubmit} className="attached segment">
            {formFields}
            <Button disabled={this.state.disableLoginBtn} primary fluid size='large'>{_msg("login.signIn")}</Button>
            {this.state.error ? <Message style={{ textAlign: 'left' }} error header={_msg("alert.loginFailed")} content={this.state.error} /> : null}
        </Form>
    }

    protected renderAdditionalRows() {
        if (!XopsMobileWrapper.isDeviceMobileApp() && !XopsMobileWrapper.isDeviceWindowsApp()) {
            return null;
        }

        return (<>
            <Grid.Row style={{ marginTop: "100px" }}><Label color="orange" content={<><Icon name={mobileDeviceEntityDescriptor.icon} /> {XopsMobileWrapper.getMobileDeviceInfo().mobileDeviceIdentifier}</>} /></Grid.Row>
            <Grid.Row>
                <NavLink to={"/" + XOPS_MOBILE_SETTINGS_PATH}><Label color="blue"><Icon name='settings' />{_msg("XopsMobile.settingsPage.title")}</Label></NavLink>
            </Grid.Row>
        </>);
    }

    protected createLoginParams(): LoginParamsInput {
        const loginParams = super.createLoginParams();
        loginParams.data = XopsMobileWrapper.getMobileDeviceInfo();
        return loginParams;
    }
}
